<script setup lang="ts">
defineProps({
  direction: String,
  width: {
    type: String,
    default: '24',
  },
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    :width="width"
  >
    <path
      fill-rule="evenodd"
      d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z"
      clip-rule="evenodd"
      v-if="direction === 'down'"
    />
    <path
      fill-rule="evenodd"
      d="M11.47 7.72a.75.75 0 011.06 0l7.5 7.5a.75.75 0 11-1.06 1.06L12 9.31l-6.97 6.97a.75.75 0 01-1.06-1.06l7.5-7.5z"
      clip-rule="evenodd"
      v-if="direction === 'up'"
    />
  </svg>
</template>
